<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('seasonTicketsCountReport.title') }}</h2>
      <p class="text-center no-print">
        {{ $t('seasonTicketsCountReport.description') }}
      </p>
    </div>

    <div class="row justify-content-end pt-3 no-print" v-if="$auth.can({confidential_report: 'read'}, 'permissions')">
      <div class="col-auto">
        <base-button type="primary" @click="adultCompensationReportRequested()" :loading="fileLoading">
          <i class="tim-icons icon-cloud-download-93"></i>
          {{ $t('seasonTicketsCountReport.adultCompensationsBtnLbl') }}
        </base-button>
        <base-button type="primary" @click="studentCompensationReportRequested()" :loading="fileLoading">
          <i class="tim-icons icon-cloud-download-93"></i>
          {{ $t('seasonTicketsCountReport.studentCompensationsBtnLbl') }}
        </base-button>
      </div>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && reportData" class="row ">
      <div class="col-6">
        <card :title="$t('seasonTicketsCountReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('seasonTicketsCountReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportData.generated_at | time }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>

    <div v-if="reportData" class="col-12 p-0">
      <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">{{ $t(`seasonTicketsCountReport.tableTitle`) }} </h4>
        <el-table row-key="id" :data="reportData.data" :empty-text="$t('generic.emptyReportForThePeriod')"
                  show-summary
                  :summary-method="getSeasonTicketsCountTableTotal">
          <el-table-column
            prop="season_ticket_id"
            :label="$t(`seasonTicketsCountReport.details.season_ticket_id`)">
          </el-table-column>
          <el-table-column
            prop="count"
            :label="$t(`generic.count`)">
          </el-table-column>
        </el-table>
      </card>
    </div>


  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import {mapActions, mapState} from "vuex";

export default {
  name: 'top-ups-report',
  components: {
    BasePagination,
    BaseAlert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      fileLoading: state => state.season_tickets_count_report.fileLoading,
      loading: state => state.season_tickets_count_report.loading,
      error: state => state.season_tickets_count_report.error,
      reportData: state => state.season_tickets_count_report.reportData,
    }),
  },
  methods: {
    ...mapActions(['GetSpecialSeasonTicketsFile', 'GetSeasonTicketsCountReport']),
    adultCompensationReportRequested() {
      this.GetSpecialSeasonTicketsFile({type: "without_assignee"})
    },
    studentCompensationReportRequested() {
      this.GetSpecialSeasonTicketsFile({type: "with_assignee"})
    },
    getSeasonTicketsCountTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('seasonTicketsCountReport.details.totalSum');
          return;
        }
        if (index === 1) {
          let values;
          values = data.map(item => Number(item.count));

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
  mounted() {
    this.GetSeasonTicketsCountReport();
  }
};
</script>

